import { useFormik } from 'formik'
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createRoleAdmin, getPermissionsAdmin } from '../../actions/permissionsAction'
import CreteRole from '../../containers/Roles/CreteRole/CreteRole'
import { useHistory } from 'react-router-dom';

const CreateRole = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { listPermissionAdmin } = useSelector(state => state.permissionsAdmin)
    const [permisionsToAdd, setPermisionsToAdd] = useState(new Set())
    useEffect(() => {
        dispatch(getPermissionsAdmin())

        return () => {

        }
    }, [])
    const validationSchema = Yup.object().shape({
        permisionsToAdd: Yup.mixed().test("size", "Requerido", (value) => {
            return value.size>0

        }),
        name: Yup.string().required('Requerido'),
    });
    const formik = useFormik({
        isInitialValid:false,
        validationSchema,
        initialValues: {
            name: "",
            permisionsToAdd: new Set()
        },onSubmit:({name,permisionsToAdd})=>{
            dispatch(createRoleAdmin({
                name,
                permissionsIds:Array.from(permisionsToAdd)
            },history))
        }
    })
    return (
        <CreteRole formik={formik} permissions={listPermissionAdmin} permisionsToAdd={permisionsToAdd} setPermisionsToAdd={setPermisionsToAdd} />
    )
}

export default CreateRole